export const COLATOOL_SITE_NAME = 'ColaTool.com';
export const COLATOOL_ORIGIN = 'https://www.colatool.com';
export const COLATOOL_DEVTOOLS_PATH = '/devtools/';

export const DEFAULT_SEO = {
  title: 'Dev Tools - JSON, URL, Base64, Hash & Encode | ColaTool.com',
  description:
    'Free online developer tools by ColaTool.com. JSON formatter, URL encode/decode, Base64, hash, JWT, HTML/CSS beautify and more — fast, private, in your browser.',
  keywords:
    'ColaTool, JSON formatter, URL encoder, Base64, hash generator, JWT decoder, HTML formatter, CSS formatter, developer tools, encode decode',
};

export function pageTitle(toolName: string): string {
  if (toolName.includes(COLATOOL_SITE_NAME)) return toolName;
  return `${toolName} - ${COLATOOL_SITE_NAME}`;
}

export function canonicalDevtoolsUrl(hashPath = ''): string {
  const path = hashPath.replace(/^\//, '').replace(/\/$/, '');
  if (!path) {
    return `${COLATOOL_ORIGIN}${COLATOOL_DEVTOOLS_PATH}`;
  }
  return `${COLATOOL_ORIGIN}${COLATOOL_DEVTOOLS_PATH}#/${path}`;
}
